import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button, Card, Form, InputGroup, Spinner, Table } from 'react-bootstrap';
import axios from 'axios';

// images import
import arrowicon from '../../../images/arrowicon.svg';
import arrowlefticon from '../../../images/arrowlefticon.svg';
import searchicon from '../../../images/searchicon.svg';
import toast from 'react-hot-toast';

// import components
import UmrahBookingsTRLoop from './UmrahBookingsTRLoop';
import { API_BASE_URL, getBearerToken } from '../../../functions';
import { useAuth } from '../auth/AuthProvider';

const UmrahBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState({ target: null, value: '' });
  const [search, setSearch] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setLoading(true);
    const tid = toast.loading("Please wait...");
    const fetchBookings = async () => {
      try {
        const url = `umrah-bookings?page=${currentPage}${searchQuery.target ? `&${searchQuery.target}=${searchQuery.value}` : ''}`;
        const response = await axios.get(`${API_BASE_URL}/${url}`, {
          headers: {
            'Authorization': `Bearer ${getBearerToken()}`
          }
        });
        
        if (currentPage === 1) {
          setBookings(response.data.data.data);
        } else {
          setBookings(prevBookings => [...prevBookings, ...response?.data?.data?.data]);
        }
        setApiResponse(response?.data?.data);
        setLoading(false);
        toast.dismiss(tid);
      } catch (error) {
        console.error(error);
        setLoading(false);
        toast.dismiss(tid);
        toast.error('Failed to fetch Umrah bookings');
      }
    };

    fetchBookings();
  }, [currentPage, search, token.role, token.id]);

  const nextPage = () => {
    if (apiResponse.next_page_url) {
      setCurrentPage(currentPage + 1);
      setLoading(true);
    }
  };

  const prevPage = () => {
    if (apiResponse.prev_page_url) {
      setCurrentPage(currentPage - 1);
      setBookings(prevBookings => prevBookings.slice(0, -apiResponse.per_page));
      setLoading(true);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchQuery.value);
    setCurrentPage(1);
  };

  return (
    <>
      <div className="main_heading mb-4 d-flex align-items-center">
        <h4>Umrah Bookings</h4>
      </div>
      
      {loading && bookings.length < 1 ? (
        <div className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <>
          <div className="bookingPage">
            <Card className="">
              <Card.Header className="px-3 px-lg-4 py-2">
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Umrah Bookings</h4>
                  <div className="d-flex align-items-center gap-3">
                    <Form onSubmit={handleSearch}>
                      <InputGroup className="mb-0 d-md-flex d-none border rounded">
                        <Form.Control
                          className="border-0"
                          placeholder="Search by PNR"
                          aria-label="Search"
                          aria-describedby="basic-addon1"
                          onChange={(e) => setSearchQuery({ target: 'pnr', value: e.target.value })}
                          value={searchQuery.target === 'pnr' ? searchQuery.value : ''}
                        />
                        <Button variant="" type="submit" id="basic-addon1">
                          <img className="img-fluid" src={searchicon} alt="icon" />
                        </Button>
                      </InputGroup>
                    </Form>
                    <Form className="me-2">
                      <InputGroup className="mb-0 d-md-flex d-none border rounded">
                        <Form.Control
                          className="border-0"
                          type="date"
                          aria-label="Date"
                          aria-describedby="basic-addon1"
                          onChange={(e) => setSearchQuery({ target: 'date', value: e.target.value })}
                          value={searchQuery.target === 'date' ? searchQuery.value : ''}
                        />
                      </InputGroup>
                    </Form>
                    {(searchQuery.target && searchQuery.value) ? (
                      <Button
                        className="redtext"
                        variant=""
                        type="button"
                        id="basic-addon1"
                        onClick={() => {
                          setSearchQuery({ target: null, value: '' });
                          setSearch(null);
                          setCurrentPage(1);
                        }}
                      >
                        Clear
                      </Button>
                    ) : null}
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="py-3 px-3 px-lg-4">
                {bookings?.length > 0 ? (
                  <UmrahBookingsTRLoop data={bookings} />
                ) : (
                  <div className="text-center py-5">
                    <p className="text-muted">No Umrah bookings found</p>
                  </div>
                )}
              </Card.Body>
              <Card.Footer className="px-3 px-lg-4 py-3 text-end" style={{ background: 'transparent' }}>
                <div className="d-flex justify-content-end">
                  <Button
                    disabled={!apiResponse?.prev_page_url}
                    className="me-2"
                    onClick={prevPage}
                  >
                    <img className="img-fluid me-1" src={arrowlefticon} alt="icon" />
                    Previous
                  </Button>
                  <Button
                    disabled={!apiResponse?.next_page_url}
                    onClick={nextPage}
                  >
                    Next
                    <img className="img-fluid ms-1" src={arrowicon} alt="icon" />
                  </Button>
                </div>
              </Card.Footer>
            </Card>
          </div>
        </>
      )}
    </>
  );
};

export default UmrahBookings;
